import { GetQuoteTransportModel } from "@factory/model/query-model-quote-transport";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { quoteTransportFormDefault } from "./form.default";
import { QuoteTransportFormSchema } from "./form.rule";

export const useFormDefaultQuoteTransport = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetQuoteTransportModel | undefined) => {
    return !cachedValue
      ? quoteTransportFormDefault
      : ({
          code: cachedValue.code,
          description: cachedValue.description,
          quotation: cachedValue.quotation,
          transportType: cachedValue.transport_type,
          transportTypeName: cachedValue.transport_type_name,
          fromLocation: cachedValue.from_location_name,
          toLocation: cachedValue.to_location_name,
          pricePerPax: cachedValue.price_per_pax,
          numPeople: cachedValue.num_people,
          unit: cachedValue.unit,
          amount: cachedValue.amount,
          childPrices: cachedValue.child_prices,
        } as QuoteTransportFormSchema);
  };

  return {
    getDefault,
  };
};
